import { useCallback } from 'react';

import { useInject } from '@vk-hr-tek/core/ioc';
import { AppError } from '@vk-hr-tek/core/error';

import { useDispatch } from '@app/hooks';
import { isReloadError } from '@app/constants';

import { UserApiService } from '../services';
import { refreshUserAndGoHome } from '../slice';

export const useLoadUnep = () => {
  const dispatch = useDispatch();
  const service = useInject(UserApiService);

  return useCallback(async () => {
    try {
      const res = await service.getUnep();

      return res.file;
    } catch (err) {
      if (err instanceof AppError && isReloadError(err.errorCode)) {
        await dispatch(refreshUserAndGoHome());
      }

      throw err;
    }
  }, [dispatch, service]);
};
